export default "__VITE_ASSET__3658d314__"